import { DatePicker, Input, Select, Form, Button, InputNumber, SelectProps, DatePickerProps } from 'antd';
import { styled } from 'styled-components';
import { MoreOutlined as EllipsisOutlined } from '@ant-design/icons';
import TextArea from 'antd/es/input/TextArea';
import { Link as RouterLink } from 'react-router-dom';
import type { Dayjs } from 'dayjs';

export const CampaignAddContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;
  padding-left: 10px;
`;

export const CampaignAddTitle = styled.div`
  width: 100%;
  padding: 20px 0;
  font-size: 25px;
  font-weight: 600;
  color: #333;
`;

export const MobileAddTitle = styled.div`
  width: 100%;
  padding: 20px 0;
  font-size: 25px;
  font-weight: 600;
  color: #333;
`;

export const InputField = styled(Input)`
  &&& {
    display: flex;

    width: 100%;
    height: 40px;
    box-sizing: border-box;
    margin-bottom: 7px;
    font-size: 14px;

    &:focus {
      border-bottom: 2px solid #40a9ff;
      box-shadow: none;
    }
  }
`;

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 880px;
`;

export const FirstPageLeftWrapper = styled.div`
  width: 100%;
`;

export const SelectFieldBox = styled.div`
  display: flex;

  gap: 10px;
`;

export const SelectField = styled(Select) <SelectProps>`
  &&& {
    display: flex;

    width: 100%;
    height: 40px;
    box-sizing: border-box;
    margin-bottom: 5px;
    font-size: 16px;

    &:focus {
      border-bottom: 2px solid #40a9ff;
      box-shadow: none;
    }
  }
`;

export const SubmitButton = styled(Button)`
  width: 100%;
  max-width: 880px;
  height: 40px;
  padding: 10px 0;
  margin-top: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  color: white;
  background-color: #0043cc;

  &:hover {
    background-color: #0056b3;
  }
`;

export const NextButton = styled(Button)`
  width: 100%;
  height: 40px;
  padding: 10px 0;
  margin-top: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  color: white;
  background-color: #0043cc;

  &:hover {
    background-color: #0056b3;
  }
`;

export const DatePickerBox = styled.div`
  display: flex;

  gap: 10px;
`;

export const StyledDatePicker = styled(DatePicker) <DatePickerProps<Dayjs>>`
  width: 100%;
  height: 40px;
  margin-bottom: 7px;
  border-radius: 5px;
`;

export const MobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 430px;
  max-width: 430px;
  padding: 15px;
  box-sizing: border-box;
  border-radius: 25px;
  border: 1px solid #ddd;
`;

export const MobileImgBox = styled(Form.Item)`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  min-height: 230px;
  margin-bottom: 0;
  cursor: pointer;

  & img {
    width: 400px;
    height: auto;
    object-fit: contain;
    text-align: center;
  }
`;

export const MobileAddContainer = styled.div`
  display: flex;

  gap: 20px;
`;

export const MobileImgInfo = styled.div`
  display: flex;
  justify-content: center;

  width: 100%;
  margin-bottom: 20px;
  color: #0043cc;
`;

export const MobileRightInfo = styled.div`
  display: flex;
  justify-content: center;

  width: 100%;
  margin-bottom: 20px;
`;

export const MobileTitle = styled.textarea`
  width: 100%;
  max-width: 400px;
  height: 100%;
  padding: 15px 10px 0 10px;
  background-color: white;
  resize: none;
  overflow: hidden;
  border: none;
  white-space: pre-wrap;
  font-weight: 700;
  text-align: center;

  &::placeholder {
    font-weight: 400;
  }

  &:focus {
    outline: none;
  }

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const MobileContentTitle = styled.div`
  width: 100%;
  max-width: 400px;
  padding: 10px 10px 0 10px;
  font-weight: 500;
  font-size: 15px;
`;

export const MobileContentBox = styled.div`
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 5px;
`;

export const MobileContentPreviewDetail = styled.div`
  color: #8f8e8f;
  font-size: 16px;
`;

export const MobileContentPreviewTitleInfo = styled.div`
  display: flex;
  justify-content: start;
  color: #39392a;
  width: 100%;
  padding-left: 10px;
  margin-bottom: 5px;
  font-weight: 700;
  background-color: #f6f6f6;
`;

export const ContentInputField = styled(TextArea)`
  width: 100%;
  max-width: 400px;
  padding: 20px;
  margin-bottom: 10px;
  background-color: white;
  white-space: pre-wrap;
  line-height: 20px;
  text-align: center;
  font-weight: 700;
`;

export const MobileContent = styled(TextArea)`
  width: 100%;
  max-width: 400px;
  max-height: 100%;
  padding: 34px;
  background-color: white;
  white-space: pre-wrap;
  line-height: 20px;
  font-size: 16px;
  overflow-y: scroll;
`;

export const MoreOutlined = styled(EllipsisOutlined)`
  border: 1px solid #f5f5f5;
  border-radius: 5px;
  box-shadow: 1px 1px 1px 0px rgba(0, 0, 0, 0.1);
  font-size: 18px;
`;

export const EllipsisText = styled.div`
  width: 200px;
  min-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CounterSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 0 10px;
`;

export const CounterTitle = styled.span``;

export const TotalCount = styled.span`
  font-size: 14px;
  color: black;
`;

export const SuccessCount = styled.span`
  font-size: 14px;
  color: #008855;
`;

export const FailCount = styled.span`
  font-size: 14px;
  color: #e74c3c;
`;

export const Divider = styled.div`
  background-color: #ccc;
`;

export const CountContainer = styled.div`
  display: flex;
`;

export const StyledFormItem = styled(Form.Item)`
  width: 100%;
  margin-bottom: 0;
`;

export const twoPageModalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  .ant-form-item-label > label {
    display: block;
    text-align: left;
  }
`;

export const FirstPageModalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  .ant-form-item-label > label {
    display: block;
    text-align: left;
  }
`;

export const StatusTag = styled.span<{ status: string }>`
  display: inline-block;

  padding: 4px 15px;
  border-radius: 15px;
  color: white;
  text-align: center;

  background-color: ${({ status }) => {
    switch (status) {
      case 'a':
        return '#0043CC';
      case 'p':
        return '#F56C6C';
      case 'd':
        return '#C0C4CC';
    }
  }};
`;

export const ThreePageModalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  gap: 20px;
`;

export const RightPreviewBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 430px;
  max-width: 430px;
  box-sizing: border-box;
  border-radius: 25px;
  border-left: 15px solid black;
  border-right: 15px solid black;
  border-top: 15px solid black;
  border-bottom: 15px solid black;
  overflow-y: hidden;
  background-color: #f6f6f6;
`;

export const MobilePreviewImgBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: white;

  & img {
    width: 100%;
  }
`;

export const MobileTitlePreview = styled.div`
  font-weight: 600;
  text-align: center;
`;

export const MobileContentPreview = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  position: relative;
  top: -35px;

  width: 90%;
  max-width: 400px;
  line-height: 20px;
  padding: 20px;
  background-color: white;
  white-space: pre-wrap;
  border-bottom: 3px solid #f9f9f9;
  border-top: 3px solid #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 20px;
  margin: 10px;
  gap: 10px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const MobilePointButton = styled.div`
  width: 100%;
  max-width: 400px;
  color: white;
  border: none;
  font-size: 17px;
  cursor: pointer;
  outline: none;
  border-radius: 5px;
  height: 40px;
  height: 100%;
  padding: 10px;
  background-color: #0043cc;
  border: 1px solid #ddd;
  border-radius: 5px;
  text-align: center;

  &:hover {
    background-color: #047af2;
  }
`;

export const MobileBtnLink = styled.a`
  width: 90%;
`;

export const ContactUsLink = styled.a`
  width: 90%;
`;

export const AdditionaTextBox = styled.div`
  width: 90%;
  position: relative;
  top: -20px;

  line-height: 25px;
  color: #3e3e3e;
  font-weight: 400;
  font-size: 14px;
  background-color: #f6f6f6;
`;

export const AdditionaTextItem = styled.div`
  display: flex;
  color: #8f8e8f;
  font-size: 14px;
  width: 100%;
`;

export const ContactUsBtn = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  color: #333;
  border: none;
  font-size: 15px;
  outline: none;
  margin: 10px 0;
  cursor: pointer;

  p {
    color: #0043cc;
  }

  &:hover {
    color: #0043cc;
  }

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const Star = styled.div`
  color: #0043cc;
  margin-right: 10px;
  font-size: 18px;
`;

export const StyledLink = styled(RouterLink) <{ current: boolean }>`
  color: ${props => (props.current ? 'black' : 'darkgray')};
  text-decoration: none;

  &:hover {
    color: ${props => (!props.current ? '#0043CC' : '#0043CC')};
  }

  &:not(:last-child)::after {
    content: ' > ';
    margin: 0 10px;
  }
`;

export const LinkNavigate = styled.div`
  display: flex;

  width: 100%;
  padding: 20px 20px 0 0;
`;

export const NoDataText = styled.div`
  padding: 10px;
  font-size: 16px;
  color: #ddd;
`;

export const ListCampaignContainer = styled.div`
  width: 400px;
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 760px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  overflow: hidden;
`;

export const WepickBoxContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-size: 2em;
  font-weight: 600;
`;

export const ListCampaignBox = styled.div`
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ListBannerImage = styled(Form.Item)`
  width: 400px;
  height: 210px;
  display: flex;
  justify-content: center;
  margin: 0;
`;

export const ListBannerImageBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  object-fit: cover;
`;

export const StyledSmallBannerImage = styled.img`
  object-fit: contain;
  object-position: center;
  width: 100%;
  height: 100%;
`;

export const ListCampaignTitle = styled.div`
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 16px;
`;

export const ListCampaignInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: 100%;

  padding: 20px;
  gap: 8px;
  line-height: 17px;

  background-color: #f6f6f6;
`;

export const ListCampaignInfoText = styled.div`
  font-size: 14px;
`;

export const ListCampaignInfoBtn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20%;
  height: 3em;
  color: white;
  background-color: #0043cc;
  border-radius: 2em;
  padding: 0 5px;
  font-size: 1em;
  font-size: 14px;

  white-space: nowrap;

  &:hover {
    background-color: '#c0c0c0';
  }
`;

export const ListTotalPointBox = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 760px;
  height: 100%;

  margin: 5px;

  font-size: 20px;
  font-weight: 700;
  line-height: 25px;
`;

export const NoImagePlaceholder = styled.div`
  font-size: 15px;
  color: #cccccc;
  margin: 70px 0;
`;

export const SmallBannerDisplay = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 880px;
  height: 100%;
  gap: 20px;

  margin-bottom: 100px;
`;


export const ExtractedTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
`;